import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const MessagesWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 55px;
  padding-bottom: 15px;
  position: relative;
  height: calc(100vh - 120px);
  top: 60px;
  margin-left: 60px;

  ${mediaMaxWidth.tablet`
    padding-top: 0;
    margin: 0 auto;
    width: calc(100vw - 20px);
  `}
`;

export const MessagesInner = styled.div`
  width: 650px;
  display: flex;
  flex-direction: column;

  ${mediaMaxWidth.tablet`
    width: 100%;
  `}
`;

export const MessagesTopBar = styled.div`
  height: 50px;
  width: 650px;
  border-radius: 8px 8px 0 0;
  padding: 0 20px;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid transparent;
  z-index: 1;
  font-weight: 600;
  font-size: 1.1em;
  flex: 0 0 auto;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0%;
    left: 1rem;
    right: 1rem;
    border-bottom: 1px solid #c6c6c6;
  }

  ${mediaMaxWidth.tablet`
    width: 100%;
  `}

  ${mediaMaxWidth.phone`
    height: 35px;
    font-size: 0.95em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.8em;
    height: 30px;
  `}
`;

export const MessagesContent = styled.div`
  overflow: scroll;
  -ms-overflow-style: none;
  padding: 0 40px 10px 40px;
  flex: 1 1 auto;
  background: #fff;
  margin-bottom: 0.5rem;
  border-radius: 0 0 8px 8px;

  &::-webkit-scrollbar {
    display: none;
  }

  ${mediaMaxWidth.phone`
    padding: 0 20px 25px 20px;
  `}
`;
